import { ReactElement } from "react";
import { Global, css } from "@emotion/react";
import { RouterProvider } from "react-router-dom";
import { FeatureFlagProvider } from "@sunrun/sales-experience-shared/react-feature-flags";
import { router } from "router";
import { useUserProfile } from "providers/UserProfile";
import { applyMfeOverrides } from "helpers/mfeOverrides";
import { DevMenuProvider } from "features/devMenu/DevMenu";

const DEV_MENU_ENVS = new Set(["local", "majstg", "staging"]);

const App = (): ReactElement => {
  applyMfeOverrides();
  const { userProfile } = useUserProfile();
  return (
    <>
      <Global
        styles={css`
          body {
            margin: 0;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
              "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
              "Helvetica Neue", sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          code {
            font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
              monospace;
          }

          * {
            box-sizing: border-box;
          }
        `}
      />
      <FeatureFlagProvider identity={userProfile?.contactId}>
        {DEV_MENU_ENVS.has(process.env.REACT_APP_ENV_NAME ?? "") ? (
          <DevMenuProvider>
            <RouterProvider router={router} />
          </DevMenuProvider>
        ) : (
          <RouterProvider router={router} />
        )}
      </FeatureFlagProvider>
    </>
  );
};

export { App };
